<template>
    <header class="mainHeader">
			
        
         <center>
             <img src="/img/ifompt_logo.png" style="width:186px;" />

         </center>
        
    </header>
</template>

<script>

export default {
    name: 'MainHeader'
}
</script>

<style scoped>

</style>